import { Component, OnInit, ViewChild, Inject, Renderer } from '@angular/core';
import { CarteraService } from 'app/services/cartera/cartera.service';
import { BitacoraGrupoComponent } from '../bitacora-grupo/bitacora-grupo.component';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material';

@Component({
  selector: 'app-bitacora-retiros',
  templateUrl: './bitacora-retiros.component.html',
  styleUrls: ['./bitacora-retiros.component.scss']
})
export class BitacoraRetirosComponent implements OnInit {

  // Variables DataTable //
  public dtOptions;
  public tableOpt = [];
  @ViewChild(DataTableDirective , {static: true}) tabla: DataTableDirective;
  public dtTrigger: Subject<void>

  /**
   * Constructor
   * 
   * @param _data 
   * @param {CarteraService} _cartera 
   * @param {Renderer} _renderer 
   * @param {MatDialog} dialog 
   */
  constructor
  (
    @Inject(MAT_DIALOG_DATA) private _data, 
    private _cartera: CarteraService, 
    private _renderer: Renderer, 
    private dialog: MatDialog
  ) 
  { 
    this.dtTrigger = new Subject();
    this.dtTrigger.next();

    this.dtOptions = {
      language: {
        sProcessing: "Procesando...",
        sLengthMenu: "Mostrar _MENU_ registros",
        sZeroRecords: "No se encontraron resultados",
        sEmptyTable: "Ningún dato disponible en esta tabla",
        sInfo: "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
        sInfoEmpty: "Mostrando registros del 0 al 0 de un total de 0 registros",
        sInfoFiltered: "(filtrado de un total de _MAX_ registros)",
        sInfoPostFix: "",
        sSearch: "Buscar:",
        sUrl: "",
        sInfoThousands: ",",
        sLoadingRecords: "Cargando...",
        oPaginate: {
          sFirst: "Primero",
          sLast: "Último",
          sNext: "Siguiente",
          sPrevious: "Anterior"
        }
      },
      columns: [
        {
          title: 'Documento',
          data: 'grunit'
        },
        {
          title: 'Radicado',
          data: 'grugru'
        },
        {
          title: 'Nombre',
          data: 'grunom'
        },
        {
          title: 'Retiros x Falta de Pago',
          render: (data, type, row, meta) => {
            return `<a>${data}</a>`
          }
        }
      ]
    }

    this.tableOpt.push(_data.info_grupo);
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On Init
   */
  ngOnInit() {}

  /**
   * After View Init
   */
  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  /**
   * On Destroy
   */
  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Renderiza la tabla
   */
  public renderer(){
    this.tabla.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    })
  }

  /**
   * Abre modal BitacoraGrupo, encargado de mostrar la bitácora del grupo en cuestión
   */
  modalBitacora(): void {
    this.dialog.open(BitacoraGrupoComponent, {
      data: {
        base_datos: this._data.base_datos,
        search_code: this._data.search_code
      }
    });
  }
}
